import React from "react";
import { useForm } from "react-hook-form";
import { BaseDropdown } from "@components/library/UI/BaseDropdown";

import "./DepositModal.sass";

// --- ICONS ---
import { ReactComponent as CloseIcon } from "@assets/images/icons/close-dropdown.svg";
import { ReactComponent as DepositIcon } from "@assets/images/icons/money-bill-transfer.svg";
import { ReactComponent as ChevronDown } from "@assets/images/icons/arrow-down-icon.svg";

const TetherIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="12" fill="#26A17B" />
    <path
      d="M13.43 9.48V10.87C15.42 11.02 16.88 11.63 16.88 12.37C16.88 13.11 15.42 13.73 13.43 13.88V17.5H10.63V13.88C8.65 13.73 7.19 13.11 7.19 12.37C7.19 11.63 8.65 11.02 10.63 10.87V9.48H6V7H18V9.48H13.43ZM12 12.87C13.82 12.87 15.29 12.44 15.29 11.91C15.29 11.38 13.82 10.95 12 10.95C10.18 10.95 8.71 11.38 8.71 11.91C8.71 12.44 10.18 12.87 12 12.87Z"
      fill="white"
    />
  </svg>
);

const BitcoinIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="12" fill="#F7931A" />
    <path
      d="M16.66 10.53C16.87 9.1 15.58 8.44 14.07 7.91L14.67 5.51L13.2 5.15L12.63 7.43C12.24 7.33 11.84 7.24 11.45 7.14L12.02 4.86L10.55 4.5L9.96 6.85C9.61 6.77 9.27 6.69 8.94 6.61L6.68 6.05L6.24 7.82C6.24 7.82 7.45 8.1 7.37 8.12C7.99 8.27 8.12 8.68 8.11 9.03L7.3 12.3C7.35 12.31 7.42 12.33 7.5 12.35L7.42 12.33L6.47 16.14C6.38 16.4 6.13 16.51 5.55 16.36C5.63 16.38 4.41 16.08 4.41 16.08L3.62 18L5.75 18.53C6.15 18.63 6.55 18.73 6.95 18.82L6.35 21.23L7.82 21.6L8.43 19.16C8.83 19.26 9.22 19.35 9.61 19.45L9.01 21.87L10.48 22.23L11.09 19.78C13.29 20.19 14.96 19.98 15.68 18.01C16.27 16.42 15.7 15.52 14.53 14.92C15.38 14.72 16.01 14.15 16.24 13.06L16.66 10.53ZM13.88 17.21C13.41 19.09 10.47 18.15 8.91 17.76L9.67 14.73C11.23 15.12 14.37 15.26 13.88 17.21ZM14.39 12.32C13.98 13.95 11.51 13.15 10.19 12.82L10.88 10.08C12.19 10.41 14.83 10.63 14.39 12.32Z"
      fill="white"
    />
  </svg>
);

const EthereumIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="12" fill="#627EEA" />
    <path
      d="M11.89 4.2L11.75 4.67V12.79L11.89 12.93L15.68 10.68L11.89 4.2Z"
      fill="white"
      fillOpacity="0.6"
    />
    <path d="M11.89 4.2L8.1 10.68L11.89 12.93V4.2Z" fill="white" />
    <path
      d="M11.89 13.78L11.81 13.87V19.38L11.89 19.61L15.69 11.55L11.89 13.78Z"
      fill="white"
      fillOpacity="0.6"
    />
    <path d="M11.89 19.61V13.78L8.1 11.55L11.89 19.61Z" fill="white" />
    <path
      d="M11.89 12.93L15.68 10.68L11.89 8.56V12.93Z"
      fill="white"
      fillOpacity="0.2"
    />
    <path
      d="M8.1 10.68L11.89 12.93V8.56L8.1 10.68Z"
      fill="white"
      fillOpacity="0.6"
    />
  </svg>
);

const LitecoinIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="12" fill="#345D9D" />
    <path
      d="M9.13 14.47L9.67 12.43H8.38L8.71 11.12H10.01L10.74 8.36L12.56 8.03L11.82 10.82H14.18L13.43 13.62L12.98 13.71L12.54 15.35H16.8L16.32 17.26H8.4L9.13 14.47Z"
      fill="white"
    />
  </svg>
);

const COINS = [
  { id: "usdt", name: "USDT", ticker: "USDT", icon: <TetherIcon /> },
  { id: "btc", name: "Bitcoin", ticker: "BTC", icon: <BitcoinIcon /> },
  { id: "eth", name: "Ethereum", ticker: "ETH", icon: <EthereumIcon /> },
  { id: "ltc", name: "Litecoin", ticker: "LTC", icon: <LitecoinIcon /> },
];

const CHAINS = [
  {
    id: "erc20",
    name: "Ethereum (ERC20)",
    confirmations: 64,
    minDeposit: "0.005 USDT",
    icon: <BitcoinIcon />,
  },
  {
    id: "trc20",
    name: "TRON (TRC20)",
    confirmations: 20,
    minDeposit: "0.005 USDT",
    icon: <TetherIcon />,
  },
  {
    id: "mantle",
    name: "Mantle Network (USDT)",
    confirmations: 700,
    minDeposit: "0.005 USDT",
    icon: <LitecoinIcon />,
  },
];

export const DepositModal = ({ active, setActive }) => {
  const { watch, setValue } = useForm({
    defaultValues: {
      coin: COINS[0],
      chain: "Select Chain",
    },
  });

  const selectedCoin = watch("coin");
  const selectedChain = watch("chain");

  if (!active) return null;

  return (
    <div className="deposit-modal-overlay" onClick={() => setActive(false)}>
      <div className="deposit-modal" onClick={(e) => e.stopPropagation()}>
        {/* HEADER */}
        <div className="deposit-modal__header">
          <div className="deposit-modal__title-group">
            <DepositIcon className="deposit-modal__title-icon" />
            <h3 className="deposit-modal__title">Deposit</h3>
          </div>
          <button
            className="deposit-modal__close-btn"
            onClick={() => setActive(false)}
          >
            <CloseIcon />
          </button>
        </div>

        {/* BODY */}
        <div className="deposit-modal__body">
          {/* COIN DROPDOWN (With Search) */}
          <div className="deposit-modal__field">
            <label className="deposit-modal__label">Coin</label>
            <BaseDropdown
              hasSearch={true}
              className="deposit-modal__dropdown"
              trigger={
                <div className="deposit-modal__trigger">
                  <div className="deposit-modal__trigger-content">
                    {selectedCoin.icon}
                    <span className="deposit-modal__trigger-text">
                      {selectedCoin.ticker}
                    </span>
                  </div>
                  <ChevronDown className="deposit-modal__chevron" />
                </div>
              }
            >
              {({ closeDropdown, searchTerm }) => {
                const filteredCoins = COINS.filter(
                  (c) =>
                    c.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    c.ticker.toLowerCase().includes(searchTerm.toLowerCase()),
                );

                return (
                  <div className="deposit-modal__menu">
                    {filteredCoins.length > 0 ? (
                      filteredCoins.map((coin) => (
                        <div
                          key={coin.id}
                          className="deposit-modal__coin-item"
                          onClick={() => {
                            setValue("coin", coin);
                            closeDropdown();
                          }}
                        >
                          <div className="deposit-modal__coin-icon">
                            {coin.icon}
                          </div>
                          <div className="deposit-modal__coin-info">
                            <span className="deposit-modal__coin-name">
                              {coin.name}
                            </span>
                            <span className="deposit-modal__coin-ticker">
                              {coin.ticker}
                            </span>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="deposit-modal__no-results">
                        No coins found
                      </div>
                    )}
                  </div>
                );
              }}
            </BaseDropdown>
          </div>

          {/* CHAIN DROPDOWN */}
          <div className="deposit-modal__field">
            <label className="deposit-modal__label">Chain Type</label>
            <BaseDropdown
              hasSearch={false}
              className="deposit-modal__dropdown"
              trigger={
                <div className="deposit-modal__trigger">
                  <span className="deposit-modal__trigger-text">
                    {selectedChain.name || "Select Chain"}
                  </span>
                  <ChevronDown className="deposit-modal__chevron" />
                </div>
              }
            >
              {({ closeDropdown }) => (
                <div className="deposit-modal__menu">
                  <div className="deposit-modal__menu-note">
                    Please ensure that you select a network that corresponds to
                    the withdrawal platform of the coin you wish to withdraw to
                    prevent potential asset losses.
                  </div>

                  {CHAINS.map((chain) => (
                    <div
                      key={chain.id}
                      className="deposit-modal__chain-item"
                      onClick={() => {
                        setValue("chain", chain);
                        closeDropdown();
                      }}
                    >
                      <div className="deposit-modal__chain-icon">
                        {chain.icon}
                      </div>
                      <div className="deposit-modal__chain-info">
                        <span className="deposit-modal__chain-name">
                          {chain.name}
                        </span>
                        <span className="deposit-modal__chain-subtext">
                          Deposit Completion: {chain.confirmations}{" "}
                          confirmation(s)
                        </span>
                        <span className="deposit-modal__chain-subtext">
                          Min. Deposit Amount {chain.minDeposit}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </BaseDropdown>
          </div>
        </div>
      </div>
    </div>
  );
};
